import { Badge, Box, IconButton, Tab, Tabs } from "@mui/material";
import { styled } from "styled-components";

import { TAB_STATUSES } from "@/constants";
import { CirclePlus, CustomizeIcon, Preview, ShareIcon } from "@/icons";

const sharedStyles = {
  icon: ({ $tabStatus }: { $tabStatus: string }) =>
    $tabStatus === TAB_STATUSES.HOMEBASE
      ? {
          verticalAlign: "middle",
        }
      : {
          fontSize: "1.3rem",
          fill: "none",
        },
  tab: {
    color: "#FFF",
    fontSize: "14px",
    fontWeight: 400,
    height: "40px",
    lineHeight: "20px",
    maxWidth: "264px",
    minHeight: "40px",
    minWidth: "72px",
    padding: "0 12px",
    textTransform: "capitalize" as const,
    "@media (min-width:600px)": {
      minWidth: "160px",
    },
    "&:focus-visible": {
      border: "1px solid white",
    },
    "& > .MuiTab-iconWrapper": {
      marginRight: "12px",
    },
    "&.MuiButtonBase-root.MuiTab-root": {
      color: "#fff",
    },
    "&.MuiButtonBase-root.MuiTab-root.Mui-selected": {
      color: "#25949D",
    },
  },
};

export const TopTabSection = styled("div")({
  display: "flex",
  zIndex: 1,
});

export const ExperienceTabsRoot = styled(Tabs)({
  height: "40px",
  minHeight: "40px",
  textTransform: "capitalize",
});

export const ExperienceTab = styled(Tab)(sharedStyles.tab);

export const ExperienceTabBadge = styled(Badge)<{ $tabStatus: string }>(({ $tabStatus }) => ({
  display: "block",
  textTransform: "capitalize",
  "& span": {
    backgroundColor: "#00AD00",
    color: "#fff",
    right: $tabStatus === TAB_STATUSES.HOMEBASE ? "2px" : "-18px",
    top: "10px",
    "@media (max-width:899px)": {
      right: $tabStatus === TAB_STATUSES.HOMEBASE ? "2px" : "-5px",
      top: $tabStatus === TAB_STATUSES.HOMEBASE ? "-5px" : "inherit",
    },
  },
}));

export const ExperienceTabBox = styled(Box)<{ $isShareDisabled: boolean }>(({ $isShareDisabled }) => ({
  ...sharedStyles.tab,
  ...($isShareDisabled
    ? {
        pointerEvents: "none",
        opacity: 0.5,
      }
    : {}),
}));

export const ExperienceIconButton = styled(IconButton)({
  padding: "0",
  "&:hover": {
    background: "transparent",
  },
});

export const ExperienceShareIcon = styled(ShareIcon)<{ $tabStatus: string }>(({ $tabStatus }) => ({
  ...sharedStyles.icon({ $tabStatus }),
  fontSize: "3rem",
}));

export const ExperienceCustomizeIcon = styled(CustomizeIcon)<{ $tabStatus: string }>(({ $tabStatus }) =>
  sharedStyles.icon({ $tabStatus }),
);

export const ExperiencePreviewIcon = styled(Preview)<{ $tabStatus: string }>(({ $tabStatus }) => ({
  ...sharedStyles.icon({ $tabStatus }),
  fontSize: "0.9rem",
  width: "18px",
}));

export const ExperienceCirclePlusIcon = styled(CirclePlus)<{ $tabStatus: string }>(({ $tabStatus }) =>
  sharedStyles.icon({ $tabStatus }),
);
